import {StudentPerformanceReport} from "../../component/studentPerformanceReport/StudentPerformanceReport";

export const StudentPerformanceReportPage = () => {
    return (
        <>
            <StudentPerformanceReport />
        </>
    )
}